module.exports = {
          srcSet: __webpack_public_path__ + "c3e09552e317ed9fb287e210638335cf-2336.png"+" 2336w",
          images:[ {path: __webpack_public_path__ + "c3e09552e317ed9fb287e210638335cf-2336.png",width: 2336,height: 472}],
          src: __webpack_public_path__ + "c3e09552e317ed9fb287e210638335cf-2336.png",
          toString:function(){return __webpack_public_path__ + "c3e09552e317ed9fb287e210638335cf-2336.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAVUlEQVR4nGPQjPf7a5kV8d8uL+afSozXfwZno//MriZgzOBo8K850f5/aqTVbwZ+P5u/UqHO/yVCnP5Jhjj/F/K3+y8cYPefz8carLA1x+9/erzzbwB1RCKwwZISMwAAAABJRU5ErkJggg==",
          width: 2336,
          height: 472
        }